import { useState, useEffect } from 'react';
import Video from '@components/Video';
import styles from './style.module.scss';
import cover from '@assets/invest.webp';
import { SOCIAL_LINKS } from '@constants/links';

const InvestIn = () => {
    const [contentIndex, setContentIndex] = useState(0);
    const textArray = [
        'UE COMIX™',
        'Ambitions',
        'The Future',
        'Technology',
        'Creativity',
        'Accessibility',
        'Dreams'
    ];
    const SocialLinks = () => {
        return SOCIAL_LINKS.map((link, index) => (
            <li key={index}>
                <a className="tile tile--filled" href={link.url} target="_blank" rel="noreferrer noopener" aria-label={link.name}>
                    <i className={`icon icon-${link.icon}`} />
                </a>
            </li>
        ))
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setContentIndex(prevIndex =>
                prevIndex === textArray.length - 1 ? 0 : prevIndex + 1
            );
        }, 1000);

        return () => clearInterval(interval);
    }, [textArray.length]);

    return (
        <section>
            <div className="container">
                <p className={styles.ptxt}>Invest In</p>
                <p className={styles.h2ChangeHead}>{textArray[contentIndex]}</p>
                <Video cover={cover} id={'sW-wkwQxs3A'} />
                <p className={styles.pInfo}>
                    <b>UE COMIX™</b> is a developing platform utilizing artificial intelligence (AI) to transform ideas into creative and innovative sequential art. We aim to support, encourage and promote a distinctive and diverse community of independent creators at all phases of the creative process. From ideas to creation, from creation to production, <b>UE COMIX™</b> will become a necessary tool for aspiring creators.
                </p>
                <ul className={`d-flex flex-wrap g-15 ${styles.socials}`}>
                    <SocialLinks />
                </ul>
            </div>
        </section>
    );
};

export default InvestIn;
